export enum TPublishingStatus {
	published = 'published',
	draft = 'draft'
}

export type TQuery = {
	[key: string]: any;
}

export enum TSortOrder {
	asc = '',
	desc = '-',
}